import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { Link } from 'react-router-dom';
import { KC_COLORS } from '../theme';

function SectionHeading({ title }) {
  if (!title) return null;
  return (
    <h2
      className="kc-related-links-title kc-type-h3 m-0 mb-5 text-left"
      style={{ color: KC_COLORS.primaryNavy }}
    >
      {title}
    </h2>
  );
}

function SubsectionHeading({ icon, children }) {
  return (
    <div className="flex items-center gap-2.5 mb-3.5">
      <span
        className="inline-flex items-center justify-center w-8 h-8 rounded-lg shrink-0"
        style={{ backgroundColor: KC_COLORS.tealLight, color: KC_COLORS.teal }}
        aria-hidden
      >
        {icon}
      </span>
      <h3
        className="kc-type-body font-bold m-0"
        style={{ color: KC_COLORS.primaryNavy }}
      >
        {children}
      </h3>
    </div>
  );
}

function GuideChip({ item }) {
  return (
    <Link to={item.href} className="kc-related-guide-chip group">
      <span className="kc-related-guide-chip-label">{item.label}</span>
      <ArrowForwardRoundedIcon
        className="kc-related-guide-chip-arrow"
        sx={{ fontSize: 16 }}
      />
    </Link>
  );
}

function ArticleRow({ item, index }) {
  return (
    <Link to={item.href} className="kc-related-article-row group">
      <span className="kc-related-article-index" aria-hidden>
        {String(index + 1).padStart(2, '0')}
      </span>
      <span className="kc-related-article-body">
        <span className="kc-related-article-label">{item.label}</span>
        <span className="kc-related-article-cta">
          Read article
          <ArrowForwardRoundedIcon sx={{ fontSize: 15 }} />
        </span>
      </span>
    </Link>
  );
}

export function RelatedLinksSection({
  title = 'Related Terms and Knowledge Center Content',
  dictionaryTerms = [],
  knowledgeCenter = [],
}) {
  const linkedGuides = dictionaryTerms.filter((item) => item?.href);
  const linkedArticles = knowledgeCenter.filter((item) => item?.href);

  if (!linkedGuides.length && !linkedArticles.length) return null;

  return (
    <div className="kc-related-links text-left">
      <SectionHeading title={title} />

      {linkedGuides.length ? (
        <div className={linkedArticles.length ? 'mb-8' : undefined}>
          <SubsectionHeading
            icon={<MenuBookOutlinedIcon sx={{ fontSize: 18 }} />}
          >
            Related Reference Guides
          </SubsectionHeading>
          <div className="kc-related-guide-grid">
            {linkedGuides.map((item) => (
              <GuideChip key={item.label} item={item} />
            ))}
          </div>
        </div>
      ) : null}

      {linkedArticles.length ? (
        <div>
          <SubsectionHeading
            icon={<ArticleOutlinedIcon sx={{ fontSize: 18 }} />}
          >
            Related Articles
          </SubsectionHeading>
          <ul className="m-0 p-0 list-none flex flex-col gap-2.5">
            {linkedArticles.map((item, index) => (
              <li key={item.label}>
                <ArticleRow item={item} index={index} />
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
